import React from "react";
import { Accordion } from "react-bootstrap";
import { AccordionToggleCustom } from "./AccordionToggleCustom";
import { BsDash, BsPlus } from "react-icons/bs";

export const FAQAccordion = ({
  faqs, //array of objects of questions and answers [{question:"hi?", answer:"hi"}]
  propsAccordion,
  styleMergeAccordionItem,
  classAccordionItem = "",
}) => {
  return (
    <Accordion {...propsAccordion}>
      {faqs.map((faq, index) => {
        // console.log(index);
        // console.log(faq);
        return (
          <div
            key={index}
            style={{
              backgroundColor: "white",
              boxShadow: "0px 0px 5px 0px rgba(0,0,0,.25)",
              marginBottom: ".75rem",
              ...styleMergeAccordionItem,
            }}
            className={classAccordionItem}
          >
            <div
              className="lead"
              style={{
                boxShadow: "0px 5px 5px -2px rgba(0,0,0,.2)",
                // paddingTop: ".75rem",
                // paddingBottom: ".75rem",
              }}
            >
              {/* <Accordion.Toggle
                  style={{
                    border: 0,
                    backgroundColor: "transparent",
                    width: "100%",
                    outline: 0,
                  }}
                  className="py-2"
                  eventKey={index}
                >
                  <span style={{ float: "left" }}>+</span>
                  {faq.question}
                </Accordion.Toggle> */}
              <AccordionToggleCustom
                eventKey={"" + index}
                styleContainer={{
                  border: 0,
                  backgroundColor: "transparent",
                  width: "100%",
                  outline: 0,
                  display: "flex",
                  alignItems: "center",
                  paddingTop: ".8rem",
                  paddingBottom: ".8rem",
                }}
                // classContainer="py-2"
                collapsedStateChildren={
                  <>
                    <BsPlus style={{ float: "left" }} />
                    <div
                      className="text-center"
                      style={{ flex: 1, marginLeft: "-10px" }}
                    >
                      {faq.question}
                    </div>
                  </>
                }
                expandedStateChildren={
                  <>
                    <BsDash style={{ float: "left" }} />
                    <div
                      className="text-center"
                      style={{ flex: 1, marginLeft: "-10px" }}
                    >
                      {faq.question}
                    </div>
                  </>
                }
              ></AccordionToggleCustom>
            </div>

            {/* doesn't seem to work if eventKey is number 0?, converted to string */}
            <Accordion.Collapse eventKey={"" + index}>
              <div className="p-2 pl-3">{faq.answer}</div>
            </Accordion.Collapse>
          </div>
        );
      })}
    </Accordion>
  );
};
